<div class="bg-white border border-gray-200 rounded-lg text-sm">
  <div class="p-3 flex items-center bg-gray-100">
    <div class="flex gap-2 items-center flex-auto" cdkDragHandle>
      <mat-icon>music_note</mat-icon>

      <span class="font-medium">Audio</span>
    </div>

    <div class="flex">
      <ng-template
        [ngTemplateOutlet]="actions() ?? null"
        [ngTemplateOutletContext]="{ $implicit: data() }"
      />
    </div>
  </div>

  <div class="p-3 border-t border-inherit">
    <div class="flex gap-1 items-center">
      <button
        mat-icon-button
        class="inline-flex! size-8! p-1! -ml-1"
        [matTooltip]="isPlaying() ? 'Audio stoppen' : 'Audio afspelen'"
        (click)="playChange.emit(data().value)"
      >
        <mat-icon>{{ isPlaying() ? 'stop' : 'play_arrow' }}</mat-icon>
      </button>
      <span class="truncate">{{ data().value.label }}</span>
    </div>
  </div>
</div>
